import React from 'react';
import Button from '../../../components/common/Button';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import crecerForms from '../../../services/api/crecer';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from '../../../components/helpers/recaptchaUtils';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const InitialSurveyForm = (props) => {
  const { student, set_student, onLookupSuccess, surveys, campus } = props;
  const [loading, set_loading] = React.useState(null);
  const getCaptchaToken = useRecaptchaToken('survey');
  const captchaRequired = isCaptchaRequired();

  async function getInfo(e) {
    e?.preventDefault?.();
    if (!student.identification || !student.phone) {
      Swal.fire('Por favor ingresa tu cédula y teléfono para continuar.');
      return;
    }

    set_loading(true);
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    crecerForms
      .getSurveyAnswers({
        phone: student.phone,
        identification: student.identification,
        captcha,
        surveys,
        campus,
      })
      .then((response) => {
        if (response?.data?.success) {
          onLookupSuccess?.(response.data, {
            identification: student.identification,
            phone: student.phone,
            captcha,
          });
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
      })
      .finally(() => {
        set_loading(false);
      });
  }

  const handleLoginInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_student({ ...student, [name]: value });
  };

  return (
    <section className="initial-survey-form">
      <RegistrationForm onSubmit={getInfo}>
        <label className="initial-survey-form__label" htmlFor="survey-identification">
          Escribe tu cédula y teléfono para comenzar
        </label>
        <div className="initial-survey-form__fields">
          <input
            id="survey-identification"
            placeholder="Cédula"
            type="number"
            name="identification"
            className="Registration__input Registration__input-id"
            value={student.identification || ''}
            disabled={loading}
            min={0}
            onChange={handleLoginInputs}
            autoComplete="username"
          />
          <input
            id="survey-phone"
            onChange={handleLoginInputs}
            name="phone"
            value={student.phone || ''}
            placeholder="Teléfono"
            disabled={loading}
            min={0}
            type="number"
            className="Registration__input Registration__input-identification"
            autoComplete="tel"
          />
        </div>
        <Button type="submit" text={loading ? 'Buscando…' : 'Continuar'} disabled={loading} />
      </RegistrationForm>
    </section>
  );
};

export default InitialSurveyForm;
